import { render, staticRenderFns } from "./TaxOffice.vue?vue&type=template&id=0dc845ac"
import script from "./TaxOffice.vue?vue&type=script&lang=js"
export * from "./TaxOffice.vue?vue&type=script&lang=js"
import style0 from "./TaxOffice.vue?vue&type=style&index=0&id=0dc845ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports